export interface AssetsResponse {
  contentStatuses: ContentRowInformation[];
}

export interface AssetResponse {
  contentID: string;
  version: string;
  jobs: Record<string, JobType>;
}

export interface QueueStats {
  pendingCount: number;
  inProgressCount: number;
  completeCount: number;
  failedCount: number;
  revokedCount: number;
}

export type QueueStatsResponse = Record<string, QueueStats>;

export interface RestartResponse {
  contentId: string;
  stepId: string;
  restartSuccessful: boolean;
}

export interface RevokeResponse {
  requestSuccessful: boolean;
}

export interface ContentRowInformation {
  contentId: string;
  version: string;
  redbeeStatus: Status;
  apolloStatus: Status;
  hbbtvStatus: Status;
  hydraDashStatus: Status;
  hydraHlsStatus: Status;
}

export type ErrorResponse = { error?: string; } | undefined;

export type LogsResponse = {
  timestamp: string;
  user: string;
  action: string;
  details?: Record<string, unknown>;
}[];

export enum Status {
  Complete = "complete",
  InProgress = "in-progress",
  Failed = "failed",
  Pending = "pending",
  Revoked = "revoked",
  Empty = "empty",
}

export interface JobType {
  status: string;
  restartAllowed: boolean;
}

export enum Pipeline {
  redbeeStatus = "RedBee Status",
  apolloStatus = "Apollo Status",
  hbbtvStatus = "HbbTV Status",
  hydraDashStatus = "Hydra DASH Status",
  hydraHlsStatus = "Hydra HLS Status",
}

export enum AssetStatus { Active, Revoked, RevokeFailed }
